import PropTypes from 'prop-types';

const themeServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  authorThemeCreate: PropTypes.func,
  authorThemeList: PropTypes.func,
  authorThemeUpdate: PropTypes.func,
  authorThemeDelete: PropTypes.func,
  authorThemeCollaboratorSummary: PropTypes.func,
  themePermissionGrant: PropTypes.func,
  themePermissionRevoke: PropTypes.func,
});

export default themeServiceShape;
